import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import './index.css';
import App from './Components';
import * as serviceWorker from './serviceWorker';
import AppConfig from 'qs-config/AppConfig';
import { setScrollStyleIfRequired } from 'qs-helpers';
import './polyfill';
import Mixpanel from 'qs-data-manager/Mixpanel';
import i18NInit from 'qs-services/i18N';

Sentry.init(AppConfig.sentry);

/*
    Attach the scrollbar style if needed before the Browser spends time rendering
    all the components. This will ensure that the scrollbar style will be available
    before the components are rendered.
*/
setScrollStyleIfRequired();

const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
const eventer = window[eventMethod];
const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
eventer(messageEvent, function(e) {
  if (e.data && e.data.func === 'trackAnalytics') {
    Mixpanel.sendEvent(e.data.params);
  }
});

i18NInit();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
